module.exports = __webpack_public_path__ + "static/media/book1.de69bf34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/inviteNew/book1.png
// module id = 1930
// module chunks = 6